export default __webpack_public_path__ + "static/media/skull.84ec31b4.png";